module.exports = __webpack_public_path__ + "Flag-643.977eacafff8a014e23d86a140201bc35.svg";